import { h, Component } from 'preact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// Actions
import { nextStepAction } from '../../actions/Section';

// Constants
import { stepTypes } from '../../constants/Steps';

// Utils
import { getStepsForRender } from '../../utilities/section/sectionUtils';
import { removeFromObject } from '../../utilities/common';
import { actionHandler } from '../../utilities/form/formUtils';

class Steps extends Component {
  componentDidMount() {
    // TODO: Fix React Flow Bug if going back and then forward quickly ( between 1-3 seconds)
    // TODO: after error then the next page won't run the actionHandler.
    const {
      pageData,
      currentProgress,
      currentValues,
      userData,
      dispatch,
      setValues,
      setFieldValue,
    } = this.props;
    const activeStepsData = getStepsForRender(pageData, currentProgress)[0];
    const data = {
      ...userData,
      ...currentValues,
      setFieldValue,
    };
    if (activeStepsData) {
      const { component: { onLoad } } = activeStepsData;
      if (onLoad) {
        actionHandler(onLoad, null, null, dispatch, data, setValues);
      }
    }
  }

  render() {
    const {
      actions,
      currentProgress,
      dispatch,
      errors,
      handleSubmit,
      isValid,
      onBlur,
      onChange,
      pageData,
      setFormValues,
      setValues,
      touched,
      values,
      userData,
      price,
      initialValues,
      setFieldValue,
      currentSectionId,
    } = this.props;
    const activeStepsData = getStepsForRender(pageData, currentProgress);
    if (activeStepsData.length === 0) {
      return <div/>;
    }

    // Params for all the items
    let stepParams = {
      errors,
      handleSubmit,
      isValid,
      nextStep: actions.nextStepAction,
      onBlur,
      onChange,
      setFormValues,
      setValues,
      touched,
      values,
      userData,
      price,
      dispatch,
      initialValues,
      setFieldValue,
      currentSectionId,
    };

    return (
      <TransitionGroup className="steps">
        {activeStepsData.map(activeStep => {
          const { component } = activeStep;
          // Params for the individual item
          const removeItems = ['componentName', 'props'];
          stepParams = {
            ...stepParams,
            ...removeFromObject(component, removeItems),
            ...component.actions ? { 'formActions': component.actions } : {},
            ...component.props ? { 'componentProps': component.props } : {},
            ...component.tracking ? { 'tracking': component.tracking } : {},
            ...component.actionProps ? { 'actionProps': component.actionProps } : {},
            submitText: component.submitText || 'Næste',
          };

          const StepComponent = stepTypes[component.componentName];
          return (
            <CSSTransition
              key={activeStep.stepId}
              classNames="slideInTop"
              timeout={300}
            >
              <StepComponent {...stepParams} />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    );
  }
}

export default compose(
  connect(
    dispatch => ({
      actions: bindActionCreators({
        nextStepAction,
      }, dispatch),
      dispatch,
    })
  )
)(Steps);

Steps.defaultProps = {
  currentValues: null,
};

Steps.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  currentProgress: PropTypes.object.isRequired,
  pageData: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  currentValues: PropTypes.object,
  actions: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  setFormValues: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  currentSectionId: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Steps/index.jsx